export default __webpack_public_path__ + "static/media/number3.916fc5c4.webp";